var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1200,
    height: 261,
    viewBox: "0 0 1200 261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_372",
    "data-name": "\\uC0AC\\uAC01\\uD615 372",
    width: 1200,
    height: 261,
    transform: "translate(360 688)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_38",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 38",
    transform: "translate(-360 -688)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_371",
    "data-name": "\\uADF8\\uB8F9 371",
    transform: "translate(-11 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_298",
    "data-name": "\\uADF8\\uB8F9 298",
    transform: "translate(383 695.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_7",
    "data-name": "\\uD569\\uCE58\\uAE30 7",
    d: "M0,107V0H196.874L225,53.5,196.874,107Z",
    transform: "translate(760 135.465)",
    fill: "#334f74"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_\\uC5F0\\uAD6C\\uC9C4\\uD589_",
    "data-name": "\\u246A \\uC5F0\\uAD6C\\uC9C4\\uD589       ",
    transform: "translate(832 191.466)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "NanumSquareR, NanumSquare"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "\u246A \uC5F0\uAD6C\uC9C4\uD589       ")), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_6",
    "data-name": "\\uD569\\uCE58\\uAE30 6",
    d: "M0,107V0H196.874L225,53.5,196.874,107Z",
    transform: "translate(760 0.464)",
    fill: "#203149"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_4",
    "data-name": "\\uD569\\uCE58\\uAE30 4",
    d: "M0,107V0H196.874L225,53.5,196.874,107Z",
    transform: "translate(570 0.464)",
    fill: "#1c2c42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_5",
    "data-name": "\\uD569\\uCE58\\uAE30 5",
    d: "M0,107V0H196.874L225,53.5,196.874,107Z",
    transform: "translate(380 0.464)",
    fill: "#19283a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_3",
    "data-name": "\\uD569\\uCE58\\uAE30 3",
    d: "M0,107V0H196.874L225,53.5,196.874,107Z",
    transform: "translate(190 0.464)",
    fill: "#162333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_2",
    "data-name": "\\uD569\\uCE58\\uAE30 2",
    d: "M0,107V0H196.874L225,53.5,196.874,107Z",
    transform: "translate(0 0.464)",
    fill: "#131e2c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_292",
    "data-name": "\\uADF8\\uB8F9 292",
    transform: "translate(0 135.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_6-2",
    "data-name": "\\uD569\\uCE58\\uAE30 6",
    d: "M0,107V0H196.874L225,53.5,196.874,107Z",
    transform: "translate(571 -0.231)",
    fill: "#304a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_4-2",
    "data-name": "\\uD569\\uCE58\\uAE30 4",
    d: "M0,107V0H196.874L225,53.5,196.874,107Z",
    transform: "translate(380.001 -0.231)",
    fill: "#2c4566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_5-2",
    "data-name": "\\uD569\\uCE58\\uAE30 5",
    d: "M0,107V0H196.875L225,53.5,196.875,107Z",
    transform: "translate(191 -0.231)",
    fill: "#29405f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_3-2",
    "data-name": "\\uD569\\uCE58\\uAE30 3",
    d: "M0,107V0H196.874L225,53.5,196.874,107Z",
    transform: "translate(0.001 -0.231)",
    fill: "#263b57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_293",
    "data-name": "\\uADF8\\uB8F9 293",
    transform: "translate(62.556 42.344)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_\\uC2E0\\uCCAD\\uC11C_\\uC791\\uC131",
    "data-name": "\\u2460 \\uC2E0\\uCCAD\\uC11C \\uC791\\uC131",
    transform: "translate(0.444 13.121)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "NanumSquareR, NanumSquare"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2460 \uC2E0\uCCAD\uC11C \uC791\uC131")), /*#__PURE__*/React.createElement("text", {
    id: "_\\uC5F0\\uAD6C\\uAE30\\uAC04_\\uC815\\uC758",
    "data-name": "\\u2461 \\uC5F0\\uAD6C\\uAE30\\uAC04 \\uC815\\uC758",
    transform: "translate(181.444 13.121)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "NanumSquareR, NanumSquare"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2461 \uC5F0\uAD6C\uAE30\uAC04 \uC815\uC758")), /*#__PURE__*/React.createElement("text", {
    id: "_\\uC5F0\\uAD6C\\uACFC\\uC81C_\\uC791\\uC131",
    "data-name": "\\u2462 \\uC5F0\\uAD6C\\uACFC\\uC81C \\uC791\\uC131",
    transform: "translate(372.444 13.121)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "NanumSquareR, NanumSquare"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2462 \uC5F0\uAD6C\uACFC\uC81C \uC791\uC131")), /*#__PURE__*/React.createElement("text", {
    id: "_\\uC5F0\\uAD6C\\uC6D0_\\uB4F1\\uB85D",
    "data-name": "\\u2463 \\uC5F0\\uAD6C\\uC6D0 \\uB4F1\\uB85D",
    transform: "translate(570.444 13.121)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "NanumSquareR, NanumSquare"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2463 \uC5F0\uAD6C\uC6D0 \uB4F1\uB85D")), /*#__PURE__*/React.createElement("text", {
    id: "_\\uB370\\uC774\\uD130_\\uC2E0\\uCCAD",
    "data-name": "\\u2464 \\uB370\\uC774\\uD130 \\uC2E0\\uCCAD",
    transform: "translate(760.445 13.121)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "NanumSquareR, NanumSquare"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2464 \uB370\uC774\uD130 \uC2E0\uCCAD"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_294",
    "data-name": "\\uADF8\\uB8F9 294",
    transform: "translate(70.255 178.041)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_\\uC790\\uB8CC\\uAD6C\\uCD95_",
    "data-name": "\\u2466 \\uC790\\uB8CC\\uAD6C\\uCD95 ",
    transform: "translate(-0.254 13.423)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "NanumSquareR, NanumSquare"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2466 \uC790\uB8CC\uAD6C\uCD95 ")), /*#__PURE__*/React.createElement("text", {
    id: "_\\uC2EC\\uC758\\uC9C4\\uD589",
    "data-name": "\\u2467 \\uC2EC\\uC758\\uC9C4\\uD589",
    transform: "translate(192.746 13.423)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "NanumSquareR, NanumSquare"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2467 \uC2EC\uC758\uC9C4\uD589")), /*#__PURE__*/React.createElement("text", {
    id: "_\\uC2EC\\uC758\\uACB0\\uACFC\\uD1B5\\uBCF4",
    "data-name": "\\u2468 \\uC2EC\\uC758\\uACB0\\uACFC\\uD1B5\\uBCF4",
    transform: "translate(367.746 13.423)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "NanumSquareR, NanumSquare"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2468 \uC2EC\uC758\uACB0\uACFC\uD1B5\uBCF4")), /*#__PURE__*/React.createElement("text", {
    id: "_\\uBE44\\uC6A9_\\uB0A9\\uBD80",
    "data-name": "\\u2469 \\uBE44\\uC6A9 \\uB0A9\\uBD80",
    transform: "translate(569.746 13.423)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "NanumSquareR, NanumSquare"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2469 \uBE44\uC6A9 \uB0A9\uBD80")))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_370",
    "data-name": "\\uADF8\\uB8F9 370",
    transform: "translate(1334.801 696.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_8",
    "data-name": "\\uD569\\uCE58\\uAE30 8",
    d: "M0,107V0H196.874L225,53.5,196.874,107Z",
    transform: "translate(0.199 -0.459)",
    fill: "#233650"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_\\uB2F4\\uB2F9\\uC790_\\uBC30\\uC815",
    "data-name": "\\u2465 \\uB2F4\\uB2F9\\uC790 \\uBC30\\uC815",
    transform: "translate(62.199 55.54)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "NanumSquareR, NanumSquare"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2465 \uB2F4\uB2F9\uC790 \uBC30\uC815")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressbar);
export default __webpack_public_path__ + "static/media/progressbar.327db51afe01d606640fcd87b6fba8a8.svg";
export { ForwardRef as ReactComponent };